import { useBottomSheet } from '@gorhom/bottom-sheet'
import { useWindowDimensions } from 'react-native'
import {
  Extrapolation,
  type SharedValue,
  interpolate,
  useAnimatedStyle,
} from 'react-native-reanimated'

// Fully hidden once the sheet head is this far down the screen.
const HIDE_AT_SCREEN_FRACTION = 0.25

/**
 * Opacity that rides the enclosing gorhom sheet's rise: opaque with the sheet
 * head at the top of the screen, gone once it has dropped a quarter of the way
 * down (the sheet covering ~75%), tracking the drag in between. Outside a sheet
 * (Storybook, tests, an embedded screen) there is nothing to track and the
 * style is a static full opacity.
 */
export function useSheetFade(enabled = true) {
  const sheetPosition = useSheetPosition()
  const position = enabled ? sheetPosition : null
  const { height } = useWindowDimensions()
  const hiddenAt = height * HIDE_AT_SCREEN_FRACTION
  return useAnimatedStyle(() => ({
    // gorhom's position is the sheet head's distance from the screen top.
    opacity: position
      ? interpolate(position.value, [0, hiddenAt], [1, 0], Extrapolation.CLAMP)
      : 1,
  }))
}

// gorhom's hook throws outside a sheet; callers fall back to static.
function useSheetPosition(): SharedValue<number> | null {
  try {
    return useBottomSheet().animatedPosition
  } catch {
    return null
  }
}
